<template>
  <div class="container">
    <div class="myBag-top">
      <Title-b :title="$t('jsbg')" />
    </div>
    <div class="one">
      <!-- <Title-b :title="$t('Personal.Modifyinformation')" /> -->
      <div class="from">
        <!-- <div>
          <span class="span">{{ $t("UserIDOne") }}：</span>
          <input type="text" class="input" v-model="res.ID"/>
        </div> -->
        <div>
          <span class="span">{{$t("Forecastpackage.couriernumber")}}：</span>
          <input
            type="text"
            class="input"
            v-model="res.kdBillCode"
            onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
          />
        </div>
        <div>
          <span class="span">{{$t("jsbg")}}：</span>
          <!-- {{ item.name }} -->
          <Select v-model="model1" style="width: 200px" @on-change="changeAddress">
            <Option
              v-for="item in addList"
              :value="item.id"
              :key="item.id"
              :label="item.name"
            ></Option>
          </Select>
        </div>
        <div class="subimt">
          <button type="button" style="color: #fff" @click="Add_BillCodeTips">
            <!-- {{ $t("Personal.Savememberinformation") }}22 -->
            {{$t("Home.Submit")}}
          </button>
        </div>
      </div>
    </div>

    <div class="date">
      <table id="table" cellspacing="0">
        <tr>
          <td>{{ $t("Myorder.Ordernumber") }}</td>
          <td>{{ $t("PromotionCenter.UserMC") }}</td>
          <td>{{$t("kdgs")}}</td>
          <td>{{$t("jslx")}}</td>
          <td>{{$t("jssj")}}</td>
          <td></td>
        </tr>
        <tr v-for="(v, n) in allOrder" :key="n">
          <td>{{ v.billcode }}</td>
          <td>{{ v.wangwang }}</td>
          <td>{{ v.kd_com }}</td>
          <td>{{ v.memo }}</td>
          <td>{{ v.input_date }}</td>
          <td>
            <img
              src="../../../assets/images/shanchu.png"
              alt=""
              style="width: 19px; height: 22px; cursor: pointer"
              @click="delAddress(n)"
            />
          </td>
        </tr>
      </table>
    </div>
    <!-- 删除对话框 -->
    <Modal
      v-model="handelModal"
      title="確認取消?"
      :loading="handelloading"
      @on-cancel="cuurrtAddressID = null"
      @on-ok="Del_BillCodeTips"
    >
      <p>確定取消拒收嗎?</p>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: {
        kdBillCode: "", // 快递单号
      },
      addList: [
        // {
        //   id: "1",
        //   name: "急件",
        // },
        {
          id: "1",
          name: "拒签",
        },
        // {
        //   id: "3",
        //   name: "先验视",
        // },
      ],
      model1: "",
      allOrder: {},
      allOderOne: [],
      ss: "",
      handelModal: false,
      handelloading: false,
      cuurrtAddressID: null,
    };
  },
  created() {
    this.Query_BillCodeTips();
  },
  methods: {
    //删除拒收
    async Del_BillCodeTips() {
      const params = {
        member_id: localStorage.getItem("userID"),
        billcode: this.cuurrtAddressID,
      };
      const { data } = await this.$post("Del_BillCodeTips", params);
      if (data.State) {
        this.Query_BillCodeTips();
        this.$Message.success("刪除成功");
      } else {
        this.$Message.error("刪除失敗");
      }
    },
    // 提交拒收
    async Add_BillCodeTips() {
      const { data } = await this.$post("Add_BillCodeTips", {
        member_id: localStorage.getItem("userID"),
        billcode: this.res.kdBillCode,
        memo: this.ss,
      });
      if (data.State) {
        this.Query_BillCodeTips();
        this.$Message.success("提交成功");
      } else {
        this.$Message.error(data.MsgText);
      }
    },
    // 查询拒收
    async Query_BillCodeTips() {
      const params = {
        MemberID: localStorage.getItem("userID"),
        offset: 1,
        limit: 1000,
      };
      const { data } = await this.$post("Query_BillCodeTips", params);
      this.allOderOne = JSON.parse(data.ReturnJson).Info;
      this.allOrder = this.allOderOne;
    },
    delAddress(n) {
      this.handelModal = true;
      this.cuurrtAddressID = this.allOrder[n].billcode;
    },
    changeAddress(vId) {
      let obj = {};
      obj = this.addList.find((item) => {
        return item.id === vId;
      });
      this.ss = obj.name;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  min-height: 750px;
  .one {
    border-radius: 5px;
    padding: 20px 0px;
    .avatar {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0 0 0 275px;
      .yuan {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.1);
        .img-style {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .change {
        border: 1px solid #666;
        width: 80px;
        height: 26px;
        border-radius: 13px;
        margin: -23px 0 0 29px;
        text-align: center;
        line-height: 26px;
        cursor: pointer;
      }
    }
    .from {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 19px 0 0 218px;
      div {
        margin: 0px 10px;
      }
      .input {
        text-indent: 10px;
        cursor: pointer;
        width: 200px;
        height: 26px;
        border-radius: 5px;
        border: 1px solid #ccc;
      }

      .subimt {
        margin: 30px 0 0 244px;
        button {
          width: 200px;
          height: 30px;
          @include backgroundColor($_color);
          // background: #ff0000;
          border-radius: 5px;
          border: 0px solid #ffffff;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
  .date {
    margin: 33px 0 0 0px;
    #table {
      width: 1029px;
      cursor: pointer;
      tr {
        height: 40px;
      }
      tr:nth-child(1) {
        @include backgroundColor($_color);
        // background: linear-gradient(0deg, #ff920a 0%, #ffaf4b 100%);
        font-size: 16px;
        color: #fff;
        td {
          color: #fff;
          font-size: 16px;
        }
      }
      td {
        width: 100px;
        font-size: 12px;
        text-align: center;
        border-bottom: 1px solid #ccc;
      }
      td:nth-child(1) {
        color: #ff9900;
        font-size: 12px;
      }
      .td:nth-child(even) {
        background: #fff;
      }
      .td:nth-child(odd) {
        background: #f1f5fe;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/rejectPackage.vue